// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"d5e082af","125":"52b51479","192":"95b18022","480":"9831fe7f","644":"675e7e74","667":"236cf1c0","744":"fad234a8","801":"dd2b6cbf","866":"79fa461d","882":"bfda0637"}[chunkId] + ".chunk.js";
};